import axios from 'axios';

export function requestStepsBase(context) {
	const $store = context.store || context.$store;
	return axios.get('/wp-json/fws/v1/booking_steps')
		.then((response) => {
			$store.commit('SET_STEPS', response.data.data.steps);
			$store.commit('SET_ALLOWED_POST_CODES', response.data.data.allowedPostCodes);
			$store.commit('SET_PRODUCTS', response.data.data.products);
		})
		.catch(e => {
			throw e;
		});
}
